function startCountdown(endDate, displays) {
  function updateCountdown() {
    const now = new Date().getTime();
    const timeLeft = endDate - now;

    if (timeLeft <= 0) {
      // Show all zeros when countdown ends
      displays.forEach((display) => {
        display.daysTens.textContent = 0;
        display.daysUnits.textContent = 0;
        display.hoursTens.textContent = 0;
        display.hoursUnits.textContent = 0;
        display.minutesTens.textContent = 0;
        display.minutesUnits.textContent = 0;
        display.secondsTens.textContent = 0;
        display.secondsUnits.textContent = 0;
      });
      clearInterval(timerInterval);
      return;
    }

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    // Update all countdown displays
    displays.forEach((display) => {
      display.daysTens.textContent = Math.floor(days / 10);
      display.daysUnits.textContent = days % 10;
      display.hoursTens.textContent = Math.floor(hours / 10);
      display.hoursUnits.textContent = hours % 10;
      display.minutesTens.textContent = Math.floor(minutes / 10);
      display.minutesUnits.textContent = minutes % 10;
      display.secondsTens.textContent = Math.floor(seconds / 10);
      display.secondsUnits.textContent = seconds % 10;
    });
  }

  const timerInterval = setInterval(updateCountdown, 1000);
  updateCountdown(); // Initial call
}

document.addEventListener("DOMContentLoaded", function () {
  const endDate = new Date("2024-11-30T23:59:59").getTime();

  // Find all countdown containers
  const countdownContainers = document.querySelectorAll(".countdown-container");

  // Create array to store all countdown displays
  const allDisplays = [];

  countdownContainers.forEach((container) => {
    const display = {
      daysTens: container.querySelector("#days-tens"),
      daysUnits: container.querySelector("#days-units"),
      hoursTens: container.querySelector("#hours-tens"),
      hoursUnits: container.querySelector("#hours-units"),
      minutesTens: container.querySelector("#minutes-tens"),
      minutesUnits: container.querySelector("#minutes-units"),
      secondsTens: container.querySelector("#seconds-tens"),
      secondsUnits: container.querySelector("#seconds-units"),
    };

    // Check if all elements exist in this container
    if (Object.values(display).every((element) => element)) {
      allDisplays.push(display);
    }
  });

  if (allDisplays.length > 0) {
    startCountdown(endDate, allDisplays);
  } else {
    console.warn("No valid countdown containers found");
  }
});
